(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-if-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'whatif_popup_dismissed';
    var popup = document.querySelector('[data-whatif-popup]');
    if (!popup) return;

    // Already dismissed this session? Don't show.
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
    } catch (e) {
      // sessionStorage may be blocked; just continue and show once.
    }

    var pausedVideos = [];

    function pauseHeroVideos() {
      var videos = document.querySelectorAll('video');
      videos.forEach(function (v) {
        if (!v.paused) {
          v.pause();
          pausedVideos.push(v);
        }
      });
    }

    function resumeHeroVideos() {
      pausedVideos.forEach(function (v) {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
      pausedVideos = [];
    }

    function open() {
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      pauseHeroVideos();
    }

    function close() {
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      resumeHeroVideos();
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    }

    // Close triggers (X button + backdrop)
    popup.querySelectorAll('[data-whatif-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // RSVP click also dismisses (and opens Partiful in new tab via target="_blank")
    var rsvp = popup.querySelector('[data-whatif-rsvp]');
    if (rsvp) {
      rsvp.addEventListener('click', function () {
        // Don't preventDefault — let the link do its thing.
        // Just mark dismissed so it doesn't reappear if they tab back.
        close();
      });
    }

    // ESC key closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });

    // Open immediately
    open();
  })();

  } catch(e) { console.error(e); }
})();
})();
